import React from "react";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import { useCallback } from "react";
import { Avatar, Paper } from "@mui/material";
import { useUserAuth } from "../contexts/authContext";

export const Chatbox = ({ messages }) => {
    const { user } = useUserAuth();

    const setLastMessageRef = useCallback((node) => {
        if (node) node.scrollIntoView({ behavior: "instant" });
    }, []);

    return (
        <Grid sx={{ flexWrap: "nowrap", display: "flex", flexDirection: "column", gap: 2, height: "100%", overflowY: "auto", px: 2 }}>
            {messages.map((message, i) => {
                const lastMessage = messages.length - 1 === i;
                const prevMessage = messages[i - 1] || messages[i];
                const prevMessageDate = new Date(prevMessage.date_sent).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric"
                });
                const newMessageDate = new Date(message.date_sent).toLocaleDateString("en-US", {
                    month: "long",
                    day: "numeric"
                });

                return message.sent_user_id !== user.id ? (
                    <Box key={i}>
                        {prevMessageDate !== newMessageDate || i === 0 ? <Divider sx={{ color: "#6b778c", p: "20px 0" }}> {newMessageDate} </Divider> : <></>}
                        <div className="cmp-ui-chat-message" ref={lastMessage ? setLastMessageRef : null}>
                            <Typography variant="caption" display="block" sx={{ pb: "8px", color: "#6b778c" }}>
                                {message.sent_user_email.split("@")[0]}{" "}
                                {new Date(message.date_sent).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}
                            </Typography>
                            <Grid container direction="row" flexDirection="row" size={8}>
                                <Grid paddingLeft={1} paddingRight={1}>
                                    <Avatar>{message.sent_user_email[0].toUpperCase()}</Avatar>
                                </Grid>
                                <Grid size={8}>
                                    <Paper sx={{ padding: "8px", marginTop: "8px", color: "text.secondary", borderRadius: "15px", borderTopLeftRadius: "2px" }}>
                                        <Box sx={{ p: "8px" }}>{message.content}</Box>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </div>
                    </Box>
                ) : (
                    <Box key={i}>
                        {prevMessageDate !== newMessageDate || i === 0 ? <Divider sx={{ color: "#6b778c", p: "20px 0" }}> {newMessageDate} </Divider> : <></>}
                        <div className="cmp-ui-chat-message" ref={lastMessage ? setLastMessageRef : null}>
                            <Typography variant="caption" display="block" sx={{ display: "flex", justifyContent: "flex-end", color: "#6b778c" }}>
                                {new Date(message.date_sent).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}
                            </Typography>
                            <Grid container direction="row" flexDirection="row-reverse" size={8}>
                                <Grid paddingLeft={1} paddingRight={1}>
                                    <Avatar>{message.sent_user_email[0].toUpperCase()}</Avatar>
                                </Grid>
                                <Grid size={8}>
                                    <Paper
                                        sx={{ padding: "8px", marginTop: "8px", color: "text.secondary", borderRadius: "15px", borderTopRightRadius: "2px" }}
                                    >
                                        <Box sx={{ p: "8px" }}>{message.content}</Box>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </div>
                    </Box>
                );
            })}
        </Grid>
    );
};
